export default __webpack_public_path__ + "static/BNCFF_Showcase_banner-7672b5cc4bec1dd8ac42bc34f978b40e.jpg";